import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';
import { LegalSellerMainInfoShared } from '@portal/models/legalSellerMainInfoShared';
import { SimpleImage } from '@portal/models/simpleImage';
import { UserResponse } from '@portal/models/userResponse';

export abstract class AvatarService {
  protected readonly avatar = new BehaviorSubject<SimpleImage | string>(undefined);

  abstract getAgentShort(): Observable<LegalSellerMainInfoShared | UserResponse>;

  setAvatar(image: SimpleImage | string) {
    this.avatar.next(image);
  }

  getAvatar(): Observable<SimpleImage | string> {
    return this.avatar.asObservable().pipe(distinctUntilChanged());
  }
}
